import { DettaglioInfoDashboardDto, LottoSmallDto } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { FormHomeDashboard, HomeDashboardReducerType } from "./types";

const homeDashboardReducer = (state: RootState): HomeDashboardReducerType => state.homeDashboard;

export const dataFormSelector = createSelector(
  homeDashboardReducer,
  (state: HomeDashboardReducerType): FormHomeDashboard => {
    return state.form;
  }
)

export const elencoDatiDashboardSelector = createSelector(
  homeDashboardReducer,
  (state: HomeDashboardReducerType): DettaglioInfoDashboardDto | undefined => {
    return state.elencoDatiDashboard;
  }
);

export const elencoLottiSelector = createSelector(
  homeDashboardReducer,
  (state: HomeDashboardReducerType): Array<LottoSmallDto> | undefined => {
    return state.elencoLotti;
  }
);
